import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import Header from "../components/landing/Header";

export default function SignupPage() {
	const [form, setForm] = useState({ email: "", password: "" });
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);

	const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError(null);
		setSuccess(null);
		const { error } = await supabase.auth.signUp(form);
		if (error) setError(error.message);
		else setSuccess("Signup successful! Check your email to confirm.");
	};

	return (
		<div className="font-sans flex flex-col min-h-screen bg-zinc-50">
			<Header />
			<form onSubmit={handleSubmit} className="max-w-sm mx-auto mt-16 space-y-4">
				<h2 className="text-2xl font-bold mb-2">Sign Up</h2>
				<input className="w-full border px-3 py-2 rounded-xl" type="email" name="email" value={form.email} placeholder="Email" onChange={handleChange} required />
				<input className="w-full border px-3 py-2 rounded-xl" type="password" name="password" value={form.password} placeholder="Password" onChange={handleChange} required />
				{error && <div className="text-red-600">{error}</div>}
				{success && <div className="text-green-600">{success}</div>}
				<button className="w-full  px-4 py-2 rounded-xl bg-sky-300 text-black font-medium hover:bg-sky-400 transition border border-sky-700 hover:border-sky-800" type="submit">
					Sign Up
				</button>
				<p className="text-neutral-500">
					Already have an account?{" "}
					<a href="/login" className="underline">
						Log in
					</a>
				</p>
			</form>
		</div>
	);
}
